<template>
  <div class="modal fade show my-2" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
    <div class="modal-dialog modal-md modal-dialog-centered" ref="modalRef">
      <div class="modal-content">
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between px-1 my-1 align-item-center">
              <h1 class="mb-0">Money Receipt</h1>
              <button
                  @click="onClickClose"
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
              ></button>
            </div>
          </div>
        </div>

        <hr class="mt-0 mb-0">

        <div class="pb-2">
          <div class="row mx-2">
            <div class="col-12">
              <label for="colFormLabel" class="col-form-label">Advance Amount</label>
              <div class="input-group">
                <input
                    v-model="formData.total_paid_amount"
                    type="number"
                    class="form-control"
                    placeholder=""
                    readonly
                />
              </div>
            </div>

            <div class="col-12">
              <label for="colFormLabel" class="col-form-label">Received In</label>
              <v-select
                  v-model="formData.account_head_id"
                  placeholder="Select Cash & Bank Account"
                  class="w-100"
                  :options="accountHeads"
                  label="name"
                  :reduce="(name) => name.id"
              />
            </div>

            <div class="col-12">
              <label for="colFormLabel" class="col-form-label">Received Ref</label>
              <input
                  type="hidden"
                  class="form-control invoice-edit-input date-picker flatpickr-input"
                  readonly="readonly"
              />
              <div class="input-group input-group-merge invoice-edit-input-group">
                <div class="input-group-text">
                  #
                </div>
                <input
                    v-model="formData.receipt_reference"
                    type="text"
                    class="form-control invoice-edit-input"
                    placeholder=""
                />
              </div>
            </div>

            <div class="col-12">
              <label for="colFormLabel" class="col-form-label">Date</label>
              <div class="input-group">
                <input
                    v-model="formData.receipt_date"
                    type="date"
                    class="form-control"
                    placeholder=""
                />
              </div>
            </div>

            <div class="col-12">
              <label for="colFormLabel" class="col-form-label">Memo</label>
              <textarea
                  v-model="formData.description"
                  placeholder="Memo"
                  class="form-control"
                  rows="2"
                  id="note"
              ></textarea>
            </div>
            <div class="col-12 pt-2">
              <input type="checkbox" id="sendSms" v-model="formData.is_sms" class="form-check-input mx-1">
              <label class="form-check-label" for="sendSms">Send SMS</label>
            </div>

            <div class="col-12 text-center mb-2 mt-2">
              <button :disabled="loading" @click="submit" type="button" class="btn btn-primary full-width me-1 waves-effect waves-float waves-light">
                <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loader v-if="loader"/>

  </div>
</template>

<script setup>
import Loader from "@/components/atom/LoaderComponent";
import {computed, inject, onMounted, ref, watch} from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';
import useDate from '@/services/utils/day'
import handleReceipt from '@/services/modules/receipt'
import handleProjects from "@/services/modules/procurement/project";
import handlePurchase from "@/services/modules/purchase";

let formData = ref({
  account_head_id: null,
  account_receivable_id: null,
  total_paid_amount: null,
  receipt_reference: null,
  description: null,
  is_sms: false,
  receipt_date: new Date().toISOString().split('T')[0],
})

const props = defineProps({
  contact: Object,
  generalData: Object
})

const emit = defineEmits(['close', 'getData']);
const $store = useStore();
const $route = useRoute();
const modalRef = ref(null);
const loading = ref(false);
const isEdit = ref(false);
const loader = ref(false);
const homeContent = ref({});
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const { formatDateTime, formatToDate } = useDate()
const projects = ref([]);
const accountHeads = ref([]);
const projectId = ref(null);

const { fetchCashAndBank } = handleReceipt()
const { createInstallmentMoneyReceipt } = handleProjects()
const { fetchAccountReceivable } = handlePurchase()

const submit = async() => {
  const query = getQuery();
  loading.value = true;
  await storeData(query)
}

const storeData = async (query) => {
  let installmentSetupData = {};
  installmentSetupData.company_id = $route.params.companyId;
  installmentSetupData.contact_profile_id = props.contact.id;
  installmentSetupData.total_paid_amount = parseFloat(props.generalData.amount);
  installmentSetupData.account_head_id = formData.value.account_head_id;
  installmentSetupData.account_receivable_id = formData.value.account_receivable_id;
  installmentSetupData.receipt_reference = formData.value.receipt_reference;
  installmentSetupData.description = formData.value.description;
  installmentSetupData.receipt_date = formData.value.receipt_date;
  installmentSetupData.is_sms = formData.value.is_sms;

  await createInstallmentMoneyReceipt(props.generalData.id, query, installmentSetupData).then((res) => {
    if (!res.status) return showError(res.message)
    emit('getData')
    onClickClose();
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

function resetForm() {
  formData.value.total_amount = null;
  formData.value.booking_money = null;
  formData.value.down_payment = null;
  formData.value.number_of_installment = null;
  formData.value.installment_frequency = null;
}

const getAccountHead = () => {
  fetchCashAndBank($route.params.companyId)
      .then(res => {
        if(res.status) {
          accountHeads.value = res.data
          formData.value.account_head_id = res.data[0].id
        }
      })
}

const getAccountReceivable = () => {
  fetchAccountReceivable(`?company_id=${$route.params.companyId}`).then(({status, data}) => {
    if (data.length < 1) {
      return formData.value.account_receivable_id = null;
    }

    formData.value.account_receivable_id = data[0].id
  })
}

onMounted( () => {
  loader.value = true;

  formData.value.total_paid_amount = props.generalData.amount
  Promise.all([
    getAccountHead(),
    getAccountReceivable(),
  ])
      .then ( () => loader.value = false)
      .catch( (err) => {
        loader.value = false
        showError( err.response.message )
      })
      .finally( () => loader.value = false)
})

const onClickClose = () => {
  emit('close')
}

function getQuery() {
  return `?company_id=${$route.params.companyId}`;
}

</script>
